import React from 'react'

import Container from 'components/Container'
import Heading from 'components/Heading'
import Meta from 'components/Meta'

export default function NotFound() {
  return (
    <div className="NotFound">
      <Meta title="Not found" />
      <Container>
        <Heading level="1">Oops! That page can’t be found.</Heading>
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.js